import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router';
import Home from "@/Ticketing/views/Home";
// import goTo from "vuetify/lib/services/goto";
import sendTicket from "@/Ticketing/views/sendTicket";
import aboutUs from "@/Ticketing/views/aboutUs";
import contactUs from "@/Ticketing/views/contactUs";
import listTickets from "@/Ticketing/views/listTickets";
import defineBanner from "@/Admin/pages/defineBanner";
import AdminLogin from "@/Admin/pages/AdminLogin";
import Dashboard from "@/Admin/pages/Dashboard";
import listBanners from "@/Admin/pages/listBanners";
import definePages from "@/Admin/pages/definePages";
import listPages from "@/Admin/pages/listPages";
import setUser from "@/Admin/pages/setUser";
import ticketsCategory from "@/Admin/pages/ticketsCategory";
import defineTicket from "@/Admin/pages/defineTicket";
import listTicketsAdmin from "@/Admin/pages/listTicketsAdmin";
import defineTask from "@/Admin/pages/defineTask";
import defineSocial from "@/Admin/pages/defineSocial";
import listSocials from "@/Admin/pages/listSocials";
import termsAndConditions from "@/Ticketing/views/TermsAndConditions";
import suggestions from "@/Ticketing/views/suggestions";
import listUsers from "@/Admin/pages/listUsers";
import defineTaskCategory from "@/Admin/pages/defineTaskCategory";
import listTasks from "@/Admin/pages/listTasks";
import listCategoryTickets from "@/Admin/pages/listCategoryTickets";
import ticketsDetail from "@/Admin/pages/ticketsDetail";
import appSetting from "@/Admin/pages/appSetting";
import editSetting from "@/Admin/pages/editSetting";
import KnowledgeCategory from "@/Admin/pages/KnowledgeCategory";
import listKnowledgeCategory from "@/Admin/pages/listKnowledgeCategory";
import knowledgeBase from "@/Admin/pages/knowledgeBase";
import listKnowledge from "@/Admin/pages/listKnowledge";
import listCategoryTasks from "@/Admin/pages/listCategoryTasks";
import taskDetail from "@/Admin/pages/taskDetail";
import profileAdmin from "@/Admin/pages/profileAdmin";
import ticketsDetailClient from "@/Ticketing/views/ticketsDetailClient";
import profile from "@/Ticketing/views/profile";
import knowledgeBaseClient from "@/Ticketing/views/knowledgeBaseClient";
import knowledgeBaseDetail from "@/Ticketing/views/knowledgeBaseDetail";
import assignmentClient from "@/Ticketing/views/assignmentClient";
import assignmentDetailClient from "@/Ticketing/views/assignmentDetailClient";
import listClientTicket from "@/Ticketing/views/listClientTicket";
import listNewTicket from "@/Ticketing/views/listNewTicket";


Vue.use(VueRouter);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/Home',
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/Home",
            component: Home,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/sendTicket",
            component: sendTicket,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/listTickets",
            component: listTickets,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/aboutUs",
            component: aboutUs,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/contactUs",
            component: contactUs,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/listNewTicket",
            component: listNewTicket,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/listClientTicket",
            component: listClientTicket,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/ticketsDetailClient",
            component: ticketsDetailClient,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/knowledgeBaseClient",
            component: knowledgeBaseClient,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/termsAndConditions",
            component: termsAndConditions,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/assignmentDetailClient",
            component: assignmentDetailClient,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/profile",
            component: profile,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/assignmentClient",
            component: assignmentClient,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/knowledgeBaseDetail",
            component: knowledgeBaseDetail,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/suggestions",
            component: suggestions,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/Admin",
            name: "AdminLogin",
            component: AdminLogin,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/Admin/Home",
            name: "Login",
            component: Dashboard
        },
        {
            path: "/Admin/defineBanner",
            name: "defineBanner",
            component: defineBanner
        },
        {
            path: "/Admin/profileAdmin",
            name: "profileAdmin",
            component: profileAdmin
        },
        {
            path: "/Admin/listKnowledge",
            name: "listKnowledge",
            component: listKnowledge
        },
        {
            path: "/Admin/appSetting",
            name: "appSetting",
            component: appSetting
        },
        {
            path: "/Admin/knowledgeBase",
            name: "knowledgeBase",
            component: knowledgeBase
        },
        {
            path: "/Admin/taskDetail",
            name: "taskDetail",
            component: taskDetail
        },
        {
            path: "/Admin/KnowledgeCategory",
            name: "KnowledgeCategory",
            component: KnowledgeCategory
        },
        {
            path: "/Admin/listKnowledgeCategory",
            name: "listKnowledgeCategory",
            component: listKnowledgeCategory
        },
        {
            path: "/Admin/listCategoryTasks",
            name: "listCategoryTasks",
            component: listCategoryTasks
        },
        {
            path: "/Admin/ticketsDetail",
            name: "ticketsDetail",
            component: ticketsDetail
        },
        {
            path: "/Admin/listBanners",
            name: "listBanners",
            component: listBanners
        },
        {
            path: "/Admin/listSocials",
            name: "listSocials",
            component: listSocials
        },
        {
            path: "/Admin/editSetting",
            name: "editSetting",
            component: editSetting
        },
        {
            path: "/Admin/definePages",
            name: "definePages",
            component: definePages
        },
        {
            path: "/Admin/listCategoryTickets",
            name: "listCategoryTickets",
            component: listCategoryTickets
        },
        {
            path: "/Admin/listPages",
            name: "listPages",
            component: listPages
        },
        {
            path: "/Admin/setUser",
            name: "setUser",
            component: setUser
        },
        {
            path: "/Admin/listTasks",
            name: "listTasks",
            component: listTasks
        },
        {
            path: "/Admin/ticketsCategory",
            name: "ticketsCategory",
            component: ticketsCategory
        },
        {
            path: "/Admin/defineTicket",
            name: "defineTicket",
            component: defineTicket
        },
        {
            path: "/Admin/listTicketsAdmin",
            name: "listTicketsAdmin",
            component: listTicketsAdmin
        },
        {
            path: "/Admin/defineTask",
            name: "defineTask",
            component: defineTask
        },
        {
            path: "/Admin/defineSocial",
            name: "defineSocial",
            component: defineSocial
        },
        {
            path: "/Admin/listUsers",
            name: "listUsers",
            component: listUsers
        },
        {
            path: "/Admin/defineTaskCategory",
            name: "defineTaskCategory",
            component: defineTaskCategory
        },

    ],
});